// @flow

import { type AppValues } from '@tectonics/app-values';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import type {UserInputValues} from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export async function cryptocurrencyOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
  appValues: AppValues,
  outgoingPayment: $Shape<OutgoingPayment>,
): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'cryptocurrency',
    payment_type_code: userInputValues['selectedCryptocurrency'],
    birth_date: formatDate(userInputValues['customerBirthdate']),
    metadata: {
      ...outgoingPayment.metadata,
      selected_protocol: userInputValues['selectedProtocol'],
    },
  };
}

// Endpoint Pay /ws/confirm expects birth_date in DD/MM/YYYY format
function formatDate(date: string): string {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}
